import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  API_URL_INPUT_STOCK_MAINTENANCE,
  API_URL_SEARCH_STOCK_MAINTENANCE,
  API_URL_STOCK_MAINTENANCE,
  API_URL_STOCK_MAINTENANCES_CANCEL,
} from 'manager/http-constants_key';
import { STOCK_MAINTENANCE_TEMPLATE } from 'manager/template-constant';
import { DICVALUES_API_CONSTANT } from 'src/app/shared/constant/api-constant';
import { CONSTANT, DATE_FORMAT } from 'src/app/shared/constant/constant';
import { STOCK_MAINTENANCE$STATUS } from 'src/app/shared/constant/db-constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';
import { InputGenerateDisplay } from 'src/app/shared/generate/generate-display/generate-display-information/generate-display-information';
import { GenerateDisplayComponent } from 'src/app/shared/generate/generate-display/generate-display.component';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';
import { GenerateInputComponent } from 'src/app/shared/generate/generate-input/generate-input.component';
import { DeleteDialogComponent } from 'src/app/shared/html-parts/delete-dialog/delete-dialog.component';
import { ExportFileService } from 'src/app/shared/html-parts/export-file/export-file.service';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { STOCK_MAINTENANCE_CONSTANT } from './constant';

@Component({
  selector: 'app-stock-maintenance',
  templateUrl: './stock-maintenance.component.html',
  styleUrls: ['../stock.component.scss'],
})

/**
 * 在庫メンテナンス管理画面
 */
export class StockMaintenanceComponent implements OnInit {
  /** 詳細画面 */
  @ViewChild(GenerateDisplayComponent)
  generateDisplayItemsComponent: GenerateDisplayComponent;

  /** 新規登録、編集、複製画面 */
  @ViewChild(GenerateInputComponent)
  generateInputComponent: GenerateInputComponent;

  /** 削除ダイアログ */
  @ViewChild(DeleteDialogComponent)
  deleteDialogComponent: DeleteDialogComponent;

  // ログインユーザ情報
  loginUser = JSON.parse(
    window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
  );

  // 検索項目生成エンドポイント
  public searchEndPoint: string = API_URL_SEARCH_STOCK_MAINTENANCE;

  // 検索項目生成テンプレートID
  public searchTemplateId: number =
    STOCK_MAINTENANCE_TEMPLATE.SEARCH_TEMPLATE_ID;

  /* 画面用プロパティ */
  // 画面ヘッダー情報格納先
  columnOrder: any[] = new Array();

  // 画面検索結果一覧格納先
  searchResultsList: any[] = new Array();

  // 辞書値格納先
  dicValuesList: any[] = new Array();

  // 検索条件保持
  generateSearchItems: Object;

  constructor(
    public datePipe: DatePipe,
    private dbOperationService: DbOperationService,
    private commonService: CommonService,
    private loadingState: LoadingState,
    private exportFileService: ExportFileService
  ) {}

  ngOnInit() {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart();

    /* ヘッダー情報取得処理(画面用) */
    this.dbOperationService
      .getHeaderList(STOCK_MAINTENANCE_TEMPLATE.SEARCH_RESULTS_TEMPLATE_ID)
      .subscribe((response) => {
        // ヘッダー情報格納
        this.columnOrder = response.body;

        // ヘッダー情報分ループ
        for (const headerInformation of response.body) {
          // ヘッダー情報に使用辞書番号が存在するか否か
          if (!headerInformation.column_dictionary_id) {
            // 使用辞書番号が存在しない場合
            continue;
          }

          /* 辞書情報を取得 */
          {
            // 使用辞書番号で辞書情報を取得する
            this.dbOperationService
              .getDicValues(headerInformation.column_dictionary_id)
              .subscribe((dicvalues) => {
                // 辞書情報を格納
                this.dicValuesList = this.dicValuesList.concat(
                  dicvalues.body[0].dic_value
                );
              });
          }
        }
      });

    // 検索処理を実施
    this.searchResult();
  }

  /**
   * 検索処理
   * @param table テーブル状態
   * @param generateSearchItems 検索条件
   */
  public searchResult(table?: any, generateSearchItems?: Object) {
    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: this.commonService.msg(MESSAGE_CODE.S00003),
      })
    );

    // CSV出力用に検索条件を保持
    this.generateSearchItems = generateSearchItems;

    /* 在庫メンテナンス一覧取得処理(画面用) */
    this.dbOperationService
      .getForkJoinData(
        STOCK_MAINTENANCE_CONSTANT.TARGET_TABLE,
        API_URL_STOCK_MAINTENANCE,
        STOCK_MAINTENANCE_TEMPLATE.SEARCH_RESULTS_TEMPLATE_ID,
        generateSearchItems
      )
      .subscribe((response) => {
        // コード値の一覧情報が存在するか否か
        if (!this.commonService.checkNoneResponse(response)) {
          // 在庫メンテナンス一覧情報のJSONをオブジェクトに格納する
          this.searchResultsList = response.body;
        } else {
          this.searchResultsList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3);
      });

    // テーブル状態が存在するか否か
    if (table) {
      // テーブル状態が存在する場合

      // テーブル状態をリセット
      table.reset();
    }
  }

  /**
   * 詳細情報画面表示
   * @param pkeyId IDコード(クリックされたID)
   */
  protected detail(pkeyId: string) {
    // 詳細画面表示
    let inputGenerateDisplay: InputGenerateDisplay = new InputGenerateDisplay();
    inputGenerateDisplay.endPoint = API_URL_STOCK_MAINTENANCE;
    inputGenerateDisplay.templateId =
      STOCK_MAINTENANCE_TEMPLATE.OUTPUT_TEMPLATE_ID;
    this.generateDisplayItemsComponent.initial(inputGenerateDisplay, pkeyId);
  }

  /**
   * 編集画面表示
   * @param pkeyId IDコード(クリックされたID)
   */
  protected edit(pkeyId: string) {
    // 編集画面表示
    this.generateInputComponent.initial(
      GENERATE_INPUT_TYPE.EDIT,
      API_URL_INPUT_STOCK_MAINTENANCE,
      API_URL_STOCK_MAINTENANCE,
      STOCK_MAINTENANCE_TEMPLATE.EDIT_INPUT_TEMPLATE_ID,
      pkeyId
    );
  }

  /**
   * 削除処理
   * @param pkeyId IDコード(クリックされたID)
   */
  protected delete(pkeyId: string) {
    // 更新情報
    let updateValue = Object();

    // 在庫ステータスにキャンセルをセット
    updateValue[STOCK_MAINTENANCE_CONSTANT.STATUS] =
      STOCK_MAINTENANCE$STATUS.STATUS_NINETY_NINE;

    // 削除ダイアログによりキャンセル処理
    this.deleteDialogComponent.cancelDialog(
      API_URL_STOCK_MAINTENANCES_CANCEL,
      this.commonService.getPkeyColumnName(this.columnOrder),
      pkeyId,
      updateValue
    );
  }

  /**
   * 再検索処理＆データ置換
   * @param table テーブル状態
   * @param pkeyId コード値
   */
  public searchReplacement(table: any, pkeyId: string) {
    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: this.commonService.msg(MESSAGE_CODE.S00004),
      })
    );

    /* データが編集かつソート実施済みの場合 */
    // テーブル状態がソート済みか否か
    if (table.sortField) {
      // テーブル状態がソート済みの場合

      // 検索処理を実施(テーブル状態初期化,検索条件あり)
      this.searchResult(table, this.generateSearchItems);

      return;
    }

    /* データが編集かつソート未実施の場合 */
    /* 在庫メンテナンス一覧再取得処理(画面用) */
    this.dbOperationService
      .getSingleData(
        API_URL_STOCK_MAINTENANCE,
        STOCK_MAINTENANCE_TEMPLATE.SEARCH_RESULTS_TEMPLATE_ID,
        this.getPkeyColumn(),
        pkeyId
      )
      .subscribe((response) => {
        /* 検索結果一覧から該当データを更新 */
        // 検索結果一覧格納先から対象のデータの行数を抽出
        const indexTargetData = this.commonService.getRowNumberArrayObject(
          this.searchResultsList,
          this.getPkeyColumn(),
          pkeyId
        );

        // 検索結果一覧情報のJSONをオブジェクトに置換する
        this.searchResultsList[indexTargetData] = response.body[0];

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadEnd();
      });
  }

  /**
   * CSV出力
   */
  protected exportCSV() {
    // csvファイル名の設定
    const fileName =
      STOCK_MAINTENANCE_CONSTANT.CSV_FILENAME +
      CONSTANT.UNDERBAR +
      this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);

    // CSVファイル出力
    this.exportFileService.exportTemplateCsv(
      fileName,
      STOCK_MAINTENANCE_CONSTANT.TARGET_TABLE,
      API_URL_STOCK_MAINTENANCE,
      STOCK_MAINTENANCE_TEMPLATE.CSV_TEMPLATE_ID,
      this.generateSearchItems
    );
  }

  /**
   * コード値変換
   * @param spName コード名称
   * @returns コード値
   */
  protected changeCode(spName: string): number {
    // コード値を取得
    const code = this.commonService.getArrayObjectValue(
      this.dicValuesList,
      DICVALUES_API_CONSTANT.NAME,
      DICVALUES_API_CONSTANT.CODE,
      spName
    );

    return code;
  }

  /**
   * プライマリーカラムを取得
   */
  protected getPkeyColumn(): string {
    return this.commonService.getPkeyColumn(this.columnOrder);
  }
}
